import {
  palette,
  createStyles,
  makeStyles,
  Theme,
} from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      width: '100%',
    },
    thumbsContainer: {
      marginTop: 16,
    },
    preview: {
      marginBottom: theme.spacing(2),
    },
    previewInfo: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: theme.spacing(1),
    },
    fileName: {
      marginRight: 'auto',
    },
    removeButton: {
      marginLeft: theme.spacing(1.5),
    },
    icon: {
      width: theme.spacing(2),
      height: theme.spacing(2),
    },
    loader: {
      position: 'relative',
      height: theme.spacing(1),
      borderRadius: theme.spacing(0.5),
      backgroundColor: theme.palette.divider,
    },
    loaderInner: {
      position: 'absolute',
      left: 0,
      height: theme.spacing(1),
      borderRadius: theme.spacing(0.5),
      backgroundColor: theme.palette.primary.main,
    },
    thumbInner: {
      display: 'flex',
      minWidth: 0,
      overflow: 'hidden',
    },
    dropzone: {
      width: '100%',
      minHeight: 160,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      padding: theme.spacing(2, 4),
      borderWidth: 2,
      borderRadius: 4,
      borderColor: theme.palette.grey[300],
      borderStyle: 'dashed',
      outline: 'none',
      transition: 'border 0.5s ease-in',
      userSelect: 'none',
    },
    dragActive: {
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.background.default,
    },
    error: {
      borderColor: theme.palette.error.main,
      backgroundColor: palette.error.background,
    },
    mainText: {
      marginBottom: theme.spacing(1),
    },
    desktopOnly: {
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    browseLink: {
      color: theme.palette.primary.main,
      cursor: 'pointer',
    },
    dialogWrapper: {
      padding: theme.spacing(4, 5),
    },
    content: {
      paddingTop: theme.spacing(4),
    },
    dialogText: {
      marginBottom: theme.spacing(6),
    },
    dialogButton: {
      display: 'block',
      marginLeft: 'auto',
    },
  })
);
